import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @className=\"disable-all-glass-global-css\" @componentName=\"UpsellModal\" @feature={{this.feature}} @onClose={{this.onClose}} @shimTag={{this.shimTag}} />", {
  moduleName: "@dashboard/shared-ui/components/saas/upsell-modal.hbs"
});